import { Card, CardProps } from '@mantine/core';

import { cx } from '../../../../Provider/Provider';
import classes from './PlaceholderCard.module.css';

interface PlaceholderCardProps extends CardProps {
  onClick?: () => void;
  className?: string;
}

const PlaceholderCard = ({ onClick, className, children, ...props }: PlaceholderCardProps) => {
  return (
    <Card
      component="button"
      onClick={onClick}
      className={cx(classes.PlaceholderCard, className)}
      {...props}
    >
      {children}
    </Card>
  );
};

export { PlaceholderCard };
